import { Box, Flex, Text } from '@chakra-ui/react';
import { VideoBox } from 'components/common/VideoBox/VideoBox';
import React, { ReactElement } from 'react';
import { getYoutubeEmbedUrl } from 'utils/youtube';

type Props = {
  videoUrl: string;
  title: string;
  description?: string;
  thumbnailUrl?: string;
  id?: string;
};

export const VideoCard = ({
  videoUrl,
  title,
  description,
  thumbnailUrl,
  id,
}: Props): ReactElement => {
  return (
    <Flex flexDir="column" gap="10px" id={id}>
      <Box
        borderRadius={8}
        overflow="hidden"
        flexGrow={1}
        width="100%"
        height={{ base: '110px', md: '180px' }}
        maxHeight={{ base: '110px', md: '180px' }}
        position="relative"
      >
        <VideoBox
          videoUrl={getYoutubeEmbedUrl(videoUrl)}
          videoDescription={description}
          isEmbedded
          thumbnailUrl={thumbnailUrl}
        />
      </Box>
      <Text
        textStyle={{ base: 'body.s.regular', md: 'body.m.regular' }}
        color="text.secondary"
        lineClamp={2}
      >
        {title}
      </Text>
    </Flex>
  );
};
